<script setup lang="ts">
import { defineProps, PropType } from 'vue'

defineProps({
  title: {
    type: String as PropType<string>,
    required: true,
  },
  subtitle: {
    type: String as PropType<string>,
    required: true,
  },
  icon: {
    type: String as PropType<string>,
    required: true,
  },
})
</script>

<template>
  <li>
    <i class="pi" :class="icon"></i>
    <section>
      <h3>{{ title }}</h3>
      <p>{{ subtitle }}</p>
    </section>
  </li>
</template>

<style scoped>
li {
  transition: 0.3s all;
  padding: 12px 16px;
  width: 100%;
  display: flex;
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  color: #86a6d9;
}

h3 {
  color: #f5f5f5;
}

li:hover {
  background-color: #3e5880;
  color: #f5f5f5;
}

li h3 {
  font-size: inherit;
  font-weight: 700;
}
</style>
